import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Button, Card, Badge } from "react-bootstrap";
import { FaSearch, FaPrint, FaFileInvoice, FaTruck, FaShoppingCart, FaMoneyBillWave, FaDownload } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import { Link } from "react-router-dom";
import * as XLSX from 'xlsx';
import api from "../services/api";

const DayBook = () => {
  // const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [transactionType, setTransactionType] = useState("all");

  // Sample transactions data
  const [transactions, setTransactions] = useState([]);

  const fetchDeliveryNotes = async () => {
    try {
      // setLoading(true);
      // setError("");
      const response = await api.post("/daybook_list.php", {});

      if (response.data.head.code === 200) {
        setTransactions(response.data.body);
      } else {
        // setError(response.data.head.msg || "Failed to fetch delivery notes");
        setTransactions([]);
      }
    } catch (err) {
      console.error("Error fetching delivery notes:", err);
      // setError("Failed to load delivery notes. Please try again.");
      setTransactions([]);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeliveryNotes();
  }, []);
  /* 
    // Filter transactions based on selected date, search term, and transaction type
    const filteredTransactions = transactions.filter(transaction => {
      const matchesDate = transaction.date === selectedDate;
      const matchesSearch = 
        transaction.document_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
        transaction.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
        transaction.description.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesType = transactionType === "all" || transaction.type === transactionType;
  
      return matchesDate && matchesSearch && matchesType;
    });
 

  /*
    // Calculate totals
    const totals = filteredTransactions.reduce((acc, transaction) => {
      return {
        totalDebit: acc.totalDebit + transaction.debit,
        totalCredit: acc.totalCredit + transaction.credit,
        closingBalance: acc.closingBalance + transaction.credit - transaction.debit
      };
    }, { totalDebit: 0, totalCredit: 0, closingBalance: 0 });
  */
  // Get opening balance (balance from previous day's last transaction)
  // const getOpeningBalance = () => {
  //   const previousDayTransactions = transactions.filter(t => t.date < selectedDate);
  //   if (previousDayTransactions.length === 0) return 0;

  //   const lastTransaction = previousDayTransactions[previousDayTransactions.length - 1];
  //   return lastTransaction.balance;
  // };

  // const openingBalance = getOpeningBalance();
  //   const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // const currentTransactions = filteredTransactions.slice(
  //   indexOfFirstItem,
  //   indexOfLastItem
  // );




  const getTransactionIcon = (type) => {
    switch (type) {
      case 'sale': return <FaFileInvoice className="text-success" />;
      case 'purchase': return <FaShoppingCart className="text-primary" />;
      case 'worker': return <FaMoneyBillWave className="text-info" />;
      // case 'receipt': return <FaMoneyBillWave className="text-success" />;
      // case 'payment': return <FaMoneyBillWave className="text-danger" />;
      // case 'delivery': return <FaTruck className="text-info" />;
      case 'expense': return <FaMoneyBillWave className="text-warning" />;
      default: return <FaFileInvoice className="text-secondary" />;
    }
  };

  const getTransactionBadge = (type) => {
    const variants = {
      sale: 'success',
      purchase: 'primary',
      worker: 'info',
      // receipt: 'success',
      // payment: 'danger',
      // delivery: 'info',
      expense: 'warning'
    };

    const labels = {
      sale: 'Sale',
      purchase: 'Purchase',
      worker: 'Worker',
      // receipt: 'Receipt',
      // payment: 'Payment',
      // delivery: 'Delivery',
      expense: 'Expense'
    };

    return (
      <Badge bg={variants[type] || 'secondary'}>
        {labels[type] || type}
      </Badge>
    );
  };

  // const handlePrint = () => {
  //   window.open(`/sds_polytechnic/daybookprint/${selectedDate}`, '_blank');
  // };



  // Helper function for export
  const getTransactionTypeLabel = (type) => {
    const labels = {
      sale: 'Sale',
      purchase: 'Purchase',
      worker: 'Worker',
      // receipt: 'Receipt',
      // payment: 'Payment',
      // delivery: 'Delivery',
      expense: 'Expense'
    };
    return labels[type] || type;
  };

  // Get summary statistics
  // const getSummaryStats = () => {
  //   const todayTransactions = transactions.filter(t => t.date === selectedDate);

  //   return {
  //     totalSales: todayTransactions.filter(t => t.type === 'sale').reduce((sum, t) => sum + t.credit, 0),
  //     totalPurchases: todayTransactions.filter(t => t.type === 'purchase').reduce((sum, t) => sum + t.debit, 0),
  //     totalReceipts: todayTransactions.filter(t => t.type === 'receipt').reduce((sum, t) => sum + t.debit, 0),
  //     totalExpenses: todayTransactions.filter(t => t.type === 'expense').reduce((sum, t) => sum + t.debit, 0),
  //     transactionCount: todayTransactions.length
  //   };
  // };

  // const stats = getSummaryStats();

  // const totalsByType = currentTransactions.reduce(
  //   (acc, tx) => {
  //     const amount = Number(tx.amount || 0);

  //     if (tx.type === "sale") {
  //       acc.totalSales += amount;
  //     } else if (tx.type === "purchase") {
  //       acc.totalPurchases += amount;
  //     } else if (tx.type === "expense") {
  //       acc.totalExpenses += amount;
  //     }

  //     return acc;
  //   },
  //   {
  //     totalSales: 0,
  //     totalPurchases: 0,
  //     totalExpenses: 0,
  //   }
  // );

  const filteredTransactions = transactions.filter((transaction) => {
    // Search
    const matchesSearch =
      !searchTerm ||
      transaction.document_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      transaction.party?.toLowerCase().includes(searchTerm.toLowerCase());

    // Type filter
    const matchesType =
      transactionType === "all" || transaction.type === transactionType;

    // Date filter (API = dd-mm-yyyy, input = yyyy-mm-dd)
    const parseDDMMYYYY = (dateStr) => {
      const [day, month, year] = dateStr.split("-");
      return new Date(year, month - 1, day);
    };

    const parseYYYYMMDD = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return new Date(year, month - 1, day);
    };

    const transactionDate = parseDDMMYYYY(transaction.date);
    const from = fromDate ? parseYYYYMMDD(fromDate) : null;
    const to = toDate ? parseYYYYMMDD(toDate) : null;

    if (to) to.setHours(23, 59, 59, 999);

    const matchesDate =
      (!from || transactionDate >= from) &&
      (!to || transactionDate <= to);

    return matchesSearch && matchesType && matchesDate;
  });
  const totalsByType = filteredTransactions.reduce(
    (acc, tx) => {
      const amount = Number(tx.amount || 0);

      if (tx.type === "sale") acc.totalSales += amount;
      if (tx.type === "purchase") acc.totalPurchases += amount;
      if (tx.type === "worker") acc.totalWorker += amount;
      if (tx.type === "expense") acc.totalExpenses += amount;

      return acc;
    },
    { totalSales: 0, totalPurchases: 0, totalWorker: 0, totalExpenses: 0 }
  );

  const totalDebit = filteredTransactions
    .filter(t => t.type !== "sale")
    .reduce((sum, t) => sum + Number(t.amount), 0);

  const totalCredit = filteredTransactions
    .filter(t => t.type === "sale")
    .reduce((sum, t) => sum + Number(t.amount), 0);

  // Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentTransactions,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredTransactions, 15);

  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Day Book</h2>

      {/* Filters and Controls */}
      <div className="filters-section mb-4 p-3 border rounded bg-light">
        <Row className="g-3 align-items-end">
          <Col xs={12} md={2} lg={2}>
            <Form.Group>
              <Form.Label>From Date:</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2} lg={2}>
            <Form.Group>
              <Form.Label>To Date:</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={2} lg={2}>
            <Form.Group>
              <Form.Label>Transaction Type</Form.Label>
              <Form.Select
                value={transactionType}
                onChange={(e) => setTransactionType(e.target.value)}
              >
                <option value="all">All Types</option>
                <option value="sale">Sales</option>
                <option value="purchase">Purchases</option>
                <option value="worker">Worker</option>
                <option value="expense">Expenses</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>Search</Form.Label>
              <Form.Control
                placeholder="Search document no, name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={2} lg={2} className="d-flex gap-2">

            <Link to="/adddaybook" className="btn-top">
              Add
            </Link>
          </Col>
        </Row>
      </div>

      {/* Summary Cards */}
      <Row className="mb-4">
        <Col xs={6} md={3}>
          <Card className="stat-card text-center border-0 bg-success text-white">
            <Card.Body>
              <h4 className="mb-1">₹{totalsByType.totalSales.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
              })}</h4>
              <small>Total Sales</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={3}>
          <Card className="stat-card text-center border-0 bg-primary text-white">
            <Card.Body>
              <h4 className="mb-1">₹{totalsByType.totalPurchases.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
              })}</h4>
              <small>Total Purchases</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={3}>
          <Card className="stat-card text-center border-0 bg-danger text-white">
            <Card.Body>
              <h4 className="mb-1">₹{totalsByType.totalWorker.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
              })}</h4>
              <small>Total Worker</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={3}>
          <Card className="stat-card text-center border-0 bg-info text-white">
            <Card.Body>
              <h4 className="mb-1">₹{totalsByType.totalExpenses.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
              })}</h4>
              <small>Total Expenses</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Transactions Table */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead className="table-dark">
              <tr>
                <th width="5%">S.No</th>
                <th width="10%">Date</th>
                <th width="10%">Type</th>
                <th width="12%">Doc.No</th>
                <th width="15%">Name</th>
                <th width="25%">Description</th>
                <th width="10%" className="text-end">Debit (₹)</th>
                <th width="10%" className="text-end">Credit (₹)</th>
                {/* <th width="13%" className="text-end">Balance (₹)</th> */}
              </tr>
            </thead>
            <tbody>

              {currentTransactions.map((transaction, index) => (
                <tr key={transaction.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{transaction.date}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      {getTransactionIcon(transaction.type)}
                      <span className="ms-2">{getTransactionBadge(transaction.type)}</span>
                    </div>
                  </td>
                  <td>
                    <strong>{transaction.document_no}</strong>
                  </td>
                  <td>{transaction.party}</td>
                  <td>
                    <small>{transaction.description}</small>
                  </td>
                  <td className="text-end">
                    {transaction.type != "sale" && (
                      <span className="text-danger fw-bold">
                        ₹{transaction.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                      </span>
                    )}
                  </td>
                  <td className="text-end">
                    {transaction.type == "sale" && (
                      <span className="text-success fw-bold">
                        ₹{transaction.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                      </span>
                    )}
                  </td>
                </tr>
              ))}

              {currentTransactions.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    <div className="text-muted">
                      <FaFileInvoice size={48} className="mb-3" />
                      <p>No transactions found for selected date</p>
                      <small>Try selecting a different date or adjusting your filters</small>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
            {currentTransactions.length > 0 && (
              <tfoot className="table-warning">
                <tr className="table-secondary fw-bold">
                  <td colSpan="6" className="text-end">Total</td>

                  <td className="text-end text-danger">
                    ₹{totalDebit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  </td>

                  <td className="text-end text-success">
                    ₹{totalCredit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  </td>
                </tr>

              </tfoot>
            )}
          </Table>
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}


    </Container>
  );
};

export default DayBook;